import {
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Grid,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MainCard from "../../components/ui-component/card/MainCard";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import CustomPopup from "../../../components/CustomPopup";
import { useNavigate } from "react-router-dom";
import CustomSnackbar from "../../components/ui-component/snackbar/CustomSnackbar";
import { fDate, fDateTime } from "../../../utils/formatTime";
import NoenquiryForm from "../../components/DataTransferComp.jsx/NoenquiryForm";
import AssignAdvisorToMissedLeads from "./AssignAdvisorToMissedLeads";
import HeadingCard from "../../newComponent/NewCardsComp/HeadingCard";
import EditIcon from "@mui/icons-material/Edit";
import EditMissedLeadsForm from "./EditMissedLeadsForm";
import EditIconcomp from "../../newComponent/iconsComp/EditIconcomp";
import SearchTextFieldComp from "../../newComponent/newtextfieldComp/SearchTextFieldComp";
import LoaderComp from "../../newComponent/LoaderComp/Loader";
import CustomNoRowsOverlay from "../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import MissedAutoAssignOtherLeads from "./MissedAutoAssignOtherLeads";
import MissMetaLead from "./MissMetaLead";
import { useGetTokenOrLogout } from "../../../utils/token";
import AssignAdvisorMetaLeads from "./AssignAdvisorMetaLeads";
import ConfirmationPopup from "../../../components/ConfirmationPopup";
import NoEnquiry from "../../components/DataTransferComp.jsx/NoEnquiry";

export default function MissedAutoAssignLeads() {
  const userId = localStorage.getItem("userId");
  console.log(userId);
  const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
  const navigate = useNavigate();
  const getTokenOrLogout = useGetTokenOrLogout();

  const [openpopup, setOpenpopup] = useState(false);
  const [openAssignPopup, setOpenAssignPopup] = useState(false);
  const [registerdata, setRegisterdate] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [selectedid, setSelectedid] = useState([]);
  const [selectedCriteria, setSelectedCriteria] = useState("other");
  const [missmetaLead, setMissMetaLead] = useState([]);
  const [missmetaOriginalLead, setMissedMetaOriginalLead] = useState([]);
  const [massCancelPopup, setMassCancelPopup] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handelopen = (rowId) => {
    setSelectedid([rowId]);
    setOpenpopup(true);
  };

  const handelclose = () => {
    setOpenpopup(false);
  };

  const handleAssignToAdvisor = () => {
    setOpenpopup(true);
  };

  const handleTaskAssign = () => {
    setOpenAssignPopup(true);
  };
  //fetch enquiry api
  useEffect(() => {
    if (selectedCriteria !== "other") return; // Only fetch if "other" is selected
    setLoading(true);
    fetch(`${API_ENDPOINT}route2.0/unassigned-enquiry/${userId}`)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else if (response.status === 403) {
          // Handle 403 error by showing Snackbar
          showSnackbar("No enq found between yeterday and today", "error");
          setLoading(false);
          return; // No need to continue further
        } else if (response.status === 401) {
          navigate("/");
          return showSnackbar("Unknown user:", "error");
        } else if (response.status === 404) {
          navigate("/page404");
          throw new Error(`Request failed with status: ${response.status}`);
        }
      })
      .then((data) => {
        if (!data) return; // Stop further execution if data is not present

        console.log(data);
        const sortedData = data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        console.log(sortedData);
        setRegisterdate(sortedData);
        setOriginalData(sortedData);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
        navigate("/page404");
      });
  }, [userId, selectedCriteria]);

  useEffect(() => {
    const fetchData = async () => {
      const token = getTokenOrLogout();
      if (!token) return;
      let headers = {
        Authorization: `Bearer ${token}`,
      };
      try {
        setLoading(true);
        const response = await fetch(
          `${API_ENDPOINT}route2.0/get-meta-leads/${userId}`,
          { headers }
        );
        const data = await response.json();
        if (response.ok) {
          setMissMetaLead(data);
          setMissedMetaOriginalLead(data);
          setLoading(false);
        } else if (response.status === 400) {
          showSnackbar(data.message, "error");
          setLoading(false);
        } else {
          showSnackbar(data.message, "error");
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    if (selectedCriteria === "metalead") {
      fetchData();
    }
  }, [userId, selectedCriteria]);

  const handleCriteria = (criteria) => {
    setSelectedCriteria(criteria);
    setSelectedid([]);
  };

  const handleMassCancelOpen = () => {
    setMassCancelPopup(true);
  };

  const handleMassCancelClose = () => {
    setMassCancelPopup(false);
    setSelectedid([])
  };

  // delete lead for meta
  const handleUpdateStatus = async () => {
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const formdata = {
      meta_lead_id: selectedid,
      user_id: parseInt(userId),
    };
    try {
      const response = await fetch(`${API_ENDPOINT}meta-lead/cancelling`, {
        method: "POST",
        headers,
        body: JSON.stringify(formdata),
      });

      const result = await response.json();
      if (response.ok || response.status === 200) {
        showSnackbar("Enquiry Deleted Successfully");

        setTimeout(() => {
          window.location.reload();
        }, 1200);
      } else if (response.status === 400) {
        showSnackbar(result.message, "error");
      } else if (response.status === 401) {
        showSnackbar(result.message, "error");
      } else if (response.status === 403) {
        showSnackbar(result.message, "error");
      } else {
        showSnackbar(result.message, "error");
      }
    } catch (error) {
      console.error("Error sending data:", error);
    }
  };

  return (
    <>
      <LoaderComp isLoading={loading} />
      <Grid container spacing={2}>
        <Grid item xs={12} md={7} lg={8} sm={12}>
          <Grid container>
            <Grid xs={12} sm={6} md={5} lg={4}>
              <HeadingCard label="Missed Auto Assign Leads" />
            </Grid>
            <Grid item xs={12} lg={8} md={7} sm={6}>
              <Chip
                label="SIEC Website and Gradlynk Leads"
                variant={
                  selectedCriteria === "other" ? "contained" : "outlined"
                }
                color={selectedCriteria === "other" ? "secondary" : undefined}
                sx={{ margin: "5px" }}
                onClick={() => handleCriteria("other")}
              />
              {/* <Chip
                label="Meta Leads"
                variant={
                  selectedCriteria === "metalead" ? "contained" : "outlined"
                }
                color={
                  selectedCriteria === "metalead" ? "secondary" : undefined
                }
                sx={{ margin: "5px" }}
                onClick={() => handleCriteria("metalead")}
              /> */}
            </Grid>
          </Grid>
        </Grid>

        {selectedCriteria === "other" && (
          <Grid
            item
            xs={12}
            lg={4}
            md={5}
            sm={12}
            sx={{ textAlign: { sm: "right" } }}
          >
            <Button
              variant="contained"
              size="small"
              color="primary"
              style={{
                borderRadius: "8px",
                marginLeft: "10px",
              }}
              onClick={handleAssignToAdvisor}
            >
              Assign To Advisor
            </Button>
          </Grid>
        )}

        {selectedCriteria === "metalead" && (
          <Grid
            item
            xs={12}
            lg={4}
            md={5}
            sm={12}
            sx={{ textAlign: { sm: "right" } }}
          >
            <Button
              variant="contained"
              size="small"
              color="error"
              style={{
                borderRadius: "8px",
                marginLeft: "10px",
              }}
              onClick={handleMassCancelOpen}
            >
              Mass Enquiry Delete
            </Button>
          </Grid>
        )}

        <Grid item xs={12}>
          {selectedCriteria === "other" && (
            <MissedAutoAssignOtherLeads
              handelclose={handelclose}
              handelopen={handelopen}
              registerdata={registerdata}
              selectedid={selectedid}
              setSelectedid={setSelectedid}
              setRegisterdate={setRegisterdate}
              originalData={originalData}
            />
          )}

          {selectedCriteria === "metalead" && (
            <MissMetaLead
              handelclose={handelclose}
              handelopen={handelopen}
              selectedid={selectedid}
              setSelectedid={setSelectedid}
              setMissedMetaOriginalLead={setMissedMetaOriginalLead}
              missmetaOriginalLead={missmetaOriginalLead}
              setMissMetaLead={setMissMetaLead}
              missmetaLead={missmetaLead}
              handleUpdateStatus={handleUpdateStatus}
            />
          )}
        </Grid>
      </Grid>

      {/* Assign to Advisor */}
      {selectedid.length === 0 ? (
        <CustomPopup
          open={openpopup}
          onClose={handelclose}
          component={<NoenquiryForm onClose={handelclose} />}
          maxWidth="xs"
        />
      ) : (
        <CustomPopup
          open={openpopup}
          onClose={handelclose}
          component={
            selectedCriteria === "other" ? (
              <AssignAdvisorToMissedLeads
                selectedid={selectedid}
                onClose={handelclose}
              />
            ) : null
          }
          title="Assign Enquiry To JCA"
          maxWidth="sm"
          showDivider={true}
        />
      )}

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />

      {selectedCriteria === "metalead" &&
        (selectedid.length === 0 ? (
          <CustomPopup
            open={massCancelPopup}
            onClose={handleMassCancelClose}
            component={
              <NoEnquiry onClose={handleMassCancelClose} text="delete" />
            }
            maxWidth="xs"
          />
        ) : (
          <ConfirmationPopup
            open={massCancelPopup}
            onClose={handleMassCancelClose}
            title="Confirmation"
            textBody="Are you sure you want to delete this lead ?"
            maxWidth="xs"
            showDivider={true}
            handleUpdateStatus={handleUpdateStatus}
          />
        ))}
    </>
  );
}
